import { useMemoizedFn } from 'ahooks';
import { openOnline } from '@/utils/index';

export const useCustomerService = () => {
  return {
    openOnline: useMemoizedFn(openOnline),
  };
};
